import React from 'react'
import {Button} from 'common/Button'
import {Navbar, NavbarGroup, NavbarTitle} from 'common/Navbar'
import {Link} from 'react-router'
import styles from './Header.scss'
import {Icon} from 'common/LegacyIcon'
import {PublishDialog} from './PublishDialog'
import {DialogButton} from 'common/DialogButton'

export const Header = ({publishStatus, onStatusChange, onPublish,
  reportSlug, saveState, onDelete, onUndo, onRedo, hasUndo, hasRedo,
  repickRides, toggleMetric, metricUnits, showHints}) =>
  (
    <div className={styles.Header}>
      <Navbar>
        <NavbarGroup>
          <li><NavbarTitle to='/ride_reports'>Ride Reports</NavbarTitle></li>
          <li><Link to='/ride_reports/drafts'>
          &laquo; back to drafts
          </Link></li>
          <li className={styles.saveStatus}>
            <SaveStatus saveState={saveState} />
          </li>
        </NavbarGroup>
        <NavbarGroup>
          <li className={styles.lessMargin}><Button type='default' onClick={onUndo} disabled={!hasUndo}>undo</Button></li>
          <li className={styles.lessMargin}><Button type='default' onClick={onRedo} disabled={!hasRedo}>redo</Button></li>
          <li className={styles.lessMargin}><DialogButton label='publish'>
            <PublishDialog currentPublishStatus={publishStatus}
              onPublish={onPublish}
              reportSlug={reportSlug} />
          </DialogButton></li>
          <li className={styles.lessMargin}><DialogButton label={<Icon i='menu' size={13} />}>
            <ul className={styles.moreList}>
              <li><a href={`/ride_reports/${reportSlug}`} target='_blank'>
                {publishStatus === 'draft' ? 'preview' : 'view report'} &raquo;
              </a></li>
              <li onClick={repickRides}><a>add/remove rides</a></li>
              <li onClick={showHints}><a>show hints</a></li>
              <li><a onClick={toggleMetric}>toggle metric {metricUnits ? '(on)' : '(off)' }</a></li>
              <li><a className={styles.delete} onClick={onDelete}>delete</a></li>
            </ul>
          </DialogButton></li>
        </NavbarGroup>
      </Navbar>
    </div>
  )

const SaveStatus = ({saveState}) => {
  if (!saveState || !saveState.unsavedChanges) {
    return <span>All changes saved.</span>
  }
  if (saveState.saveFailed && !saveState.savePending) {
    return <span className={styles.errorMessage}>We had a problem saving your report.</span>
  }
  return <span>Saving...</span>
}
